import { createContext } from "react";

const WalletIDMainContext = createContext();

export default WalletIDMainContext;